import { Add, ChevronRight, Delete, ExpandMore, Save } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { FC } from 'react';
import { SmartModuleTitleCard } from 'src/components/organisms/SmartModuleTitleCard/SmartModuleTitleCard';
import { StyledActionButton } from 'src/components/styled/ActionButton';
import { StyledDiscardButton } from 'src/components/styled/DiscardButton';

interface ClusterManagementTopBarProps {
    onExpandAll: () => void;
    onCollapseAll: () => void;
    onAddCluster: () => void;
    onDiscardChanges: () => void;
    onSaveChanges: () => void;
    isDiscardButtonDisabled: boolean;
    isSaveButtonDisabled: boolean;
    isSaving: boolean;
}

export const ClusterManagementTopBar: FC<ClusterManagementTopBarProps> = ({
    onExpandAll,
    onCollapseAll,
    onAddCluster,
    onDiscardChanges,
    onSaveChanges,
    isDiscardButtonDisabled,
    isSaveButtonDisabled,
    isSaving,
}) => {
    return (
        <Stack
            direction="column"
            sx={{
                gap: 2,
            }}
        >
            <SmartModuleTitleCard />
            <Stack
                direction="row"
                sx={{
                    justifyContent: 'flex-end',
                    gap: 4,
                }}
            >
                <Button color="primary" variant="text" onClick={() => onExpandAll()} startIcon={<ExpandMore />}>
                    Expand All
                </Button>
                <Button color="primary" variant="text" onClick={() => onCollapseAll()} startIcon={<ChevronRight />}>
                    Collapse All
                </Button>
                <Button
                    color="primary"
                    variant="text"
                    onClick={() => onAddCluster()}
                    startIcon={<Add />}
                    disabled={isSaving}
                >
                    New Cluster
                </Button>
                <StyledDiscardButton
                    disabled={isDiscardButtonDisabled || isSaving}
                    color="error"
                    variant="contained"
                    size="medium"
                    startIcon={<Delete />}
                    onClick={() => onDiscardChanges()}
                >
                    Discard
                </StyledDiscardButton>
                <StyledActionButton
                    variant="contained"
                    size="medium"
                    onClick={() => onSaveChanges()}
                    startIcon={<Save />}
                    disabled={isSaveButtonDisabled || isSaving}
                    loading={isSaving}
                >
                    Save
                </StyledActionButton>
            </Stack>
        </Stack>
    );
};
